<template>
  <div class="form-wrap">
    <el-alert
      style="width: 400px;margin: 0 0 20px"
      title="为保证微信小程序端相关功能的正常使用，请确保下方表单中的微信手机号与您微信绑定的手机号一致！"
      type="warning"
      show-icon
      :closable="false">
    </el-alert>
    <el-card shadow="always">
      <el-form
        ref="ruleForm"
        :model="userInfo"
        :rules="rules"
        label-width="110px">
        <el-form-item label="公司名称：">{{ userInfo.corpName }}</el-form-item>
        <el-form-item label="姓名：">{{ userInfo.name }}</el-form-item>
        <el-form-item label="手机号：">{{ userInfo.mobilePhone }}</el-form-item>
        <el-form-item label="邮箱：">{{ userInfo.email }}</el-form-item>
        <el-form-item label="部门：">{{ userInfo.department }}</el-form-item>
        <el-form-item label="职位：">{{ userInfo.position }}</el-form-item>
        <el-form-item
          label="微信手机号："
          prop="wxMobilePhone">
          <el-input v-model="userInfo.wxMobilePhone"></el-input>
        </el-form-item>
        <el-form-item label-width="0">
          <el-button
            style="width:100%"
            type="primary"
            @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { navigateToLogin } from '../../utils/navigateToLogin'
export default {
  name: 'AddressBookConfirm',
  data() {
    return {
      userInfo: {},
      rules: {
        wxMobilePhone: [
          { required: true, message: '请输入微信手机号', trigger: 'blur' },
          {
            pattern: /^1[0-9][0-9]\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.userInfo = {
      ...this.userInfo,
      ...this.$route.query
    }
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm('您确定提交信息吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true
            this.$store.dispatch('account/confirmnamecard', {
              payload: {
                check: this.userInfo.check,
                wxMobilePhone: this.userInfo.wxMobilePhone
              },
              success: () => {
                this.loading = false
                this.$message.success('提交成功')
                setTimeout(() => {
                  // this.$router.push(`/login`)
                  navigateToLogin()
                }, 1500)
              },
              fail: () => {
                this.loading = false
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.form-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction column;
  align-items: center;
  justify-content: center;
}
</style>
